<template>
  <div class="card-tech">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'Card',
  };
</script>

<style scoped>
  /* Card styling is now handled by Tailwind's card-tech class */
</style>
